import WarehouseIcon from '@mui/icons-material/Warehouse';

export const warehouseAutomationCountingStrategiesConfig = {
    all:  {
        title: 'all',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
};
